module.exports = __webpack_public_path__ + "static/img_0330_dpp_optimized-6a04934b3bfff09692249e80b9b2cf89.jpg";